import { render } from "./FrancaisSimpleMaterials.vue?vue&type=template&id=74fe8fcc"
import script from "./FrancaisSimpleMaterials.vue?vue&type=script&lang=js"
export * from "./FrancaisSimpleMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__